import type { SolutionTheme } from "./solutions";

const greenSolutionTheme = {
  accentText: "text-brand-green",
  accentBg: "bg-primary-700",
  accentBorder: "border-brand-green-line",
  tintBg: "bg-brand-green-soft",
  darkBg: "bg-[#062b20]",
  button: "bg-primary-700 hover:bg-primary-800 text-white",
  outlineButton: "border-brand-green-line text-brand-green hover:bg-brand-green-soft",
  icon: "bg-brand-green-soft text-brand-green",
  focus: "focus-visible:ring-primary-700",
};

export const solutionThemeStyles: Record<
  SolutionTheme,
  {
    accentText: string;
    accentBg: string;
    accentBorder: string;
    tintBg: string;
    darkBg: string;
    button: string;
    outlineButton: string;
    icon: string;
    focus: string;
  }
> = {
  yonda: {
    accentText: "text-brand-violet",
    accentBg: "bg-violet-700",
    accentBorder: "border-brand-violet-line",
    tintBg: "bg-brand-violet-soft",
    darkBg: "bg-violet-950",
    button: "bg-violet-700 hover:bg-violet-800 text-white",
    outlineButton: "border-brand-violet-line text-brand-violet hover:bg-brand-violet-soft",
    icon: "bg-brand-violet-soft text-brand-violet",
    focus: "focus-visible:ring-violet-700",
  },
  magneto: greenSolutionTheme,
  turnalar: {
    accentText: "text-brand-amber",
    accentBg: "bg-[#e6b52e]",
    accentBorder: "border-brand-amber-line",
    tintBg: "bg-brand-amber-soft",
    darkBg: "bg-[#28251d]",
    button:
      "bg-[#e6b52e] hover:bg-[#d5a522] active:bg-[#c4961a] text-[#28251d]",
    outlineButton:
      "border-brand-amber-line text-brand-amber hover:bg-brand-amber-soft active:bg-brand-amber-soft",
    icon: "bg-brand-amber-soft text-brand-amber",
    focus: "focus-visible:ring-[#85600c]",
  },
};
